import type { InboxViewColumn, InboxViewRow } from "@/types/inboxView/inboxView";
import { safeFilename, saveBlob } from "./exportFile";

const escapeCell = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  const str = typeof value === "string" ? value : JSON.stringify(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export function exportViewToCsv(
  viewName: string,
  columns: InboxViewColumn[],
  rows: InboxViewRow[],
): void {
  if (columns.length === 0) return;
  // Scores and the match reason are appended only when the rows carry them, so
  // a view that has not been upgraded keeps its familiar file.
  const screened = rows.some((row) => !!row.scores || !!row.match_reason);
  const extraHeader = screened ? ["Match", "Urgency", "Intent", "Why It Qualified"] : [];
  const header = [...columns.map((c) => c.name), ...extraHeader].map(escapeCell).join(",");
  const body = rows
    .map((row) =>
      [
        ...columns.map((c) => row.data?.[c.name]),
        ...(screened ? [row.scores?.match, row.scores?.urgency, row.scores?.intent, row.match_reason] : []),
      ]
        .map(escapeCell)
        .join(","),
    )
    .join("\n");
  const csv = `${header}\n${body}`;

  saveBlob(new Blob([csv], { type: "text/csv;charset=utf-8;" }), `${safeFilename(viewName)}.csv`);
}
